<template>
    <div class='main'>
        <div class='content'>
            <div class='content-header'>
                <h3>カメラマン管理</h3>
                <button class='right-block button is-info' @click='changeActive'>新規追加</button>
            </div>
            <ul class='list'>
                <li v-for="(photographer) in photographers" :key="photographer.id" :value="photographer.id" class='list-item' role="button" tabindex="0" @click='detail(photographer.id)' @keydown.enter.prevent='detail(photographer.id)' @keydown.space.prevent='detail(photographer.id)'>
                    <input type='text' :id='`enabled-${photographer.id}`' :value='photographer.name' disabled>
                    <div class='right-block'>
                        <span class='icon' @click.stop='trash(photographer.id)'><i class='fas fa-trash' aria-hidden='true'></i></span>
                    </div>
                </li>
            </ul>
        </div>

        <div class="modal" :class="{ 'is-active': isActive }">
            <div class="modal-background" @click='changeActive'></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">カメラマン新規追加</p>
                    <button class="delete" aria-label="close" @click='changeActive'></button>
                </header>
                <section class="modal-card-body">
                    <div class="field">
                        <label class="label">名前</label>
                        <div class="control">
                            <input class="input" type="text" v-model='name' placeholder="名前">
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">メールアドレス</label>
                        <div class="control">
                            <input class="input" type="text" v-model='email' placeholder="256文字以下" maxlength='256' required>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">パスワード</label>
                        <div class="control">
                            <input class="input" type="text" v-model='password' placeholder="256文字以下" maxlength='256' required>
                        </div>
                    </div>
                    <div class="field">
                        <div class="control">
                            <button class="button is-link" @click="autoGenerate('password')">自動生成</button>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">カメラマンコード</label>
                        <div class="control">
                            <input class="input" type="text" v-model='code' placeholder="20文字以下" maxlength='20' required>
                        </div>
                    </div>

                </section>
                <footer class="modal-card-foot">
                    <div class='right-block'>
                        <button class="button is-info" @click='add'>送信</button>
                        <button class="button" @click='changeActive'>閉じる</button>
                    </div>
                </footer>
            </div>
            <button class="modal-close is-large" aria-label="close" @click='changeActive'></button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'School',
    components: {
    },
    data () {
        return {
            isActive: false,
            email: '',
            name: '',
            code: '',
            password: '',
            photographers: []
        }
    },
    mounted () {
        const self = this
        const params = this.$parent.requestParams

        this.axios.get(`${process.env.API_URL}/photographer${params}`).then((res) => {
            self.photographers = res.data.users
        }).catch((e) => {
            alert('サーバーエラーが発生しました')
        })
    },
    methods: {
        changeActive () {
            this.isActive = !this.isActive

            if (this.isActive) {
                this.autoGenerate('password')
            }
        },
        trash (key) {
            if (window.confirm('削除したカメラマンに関連する全ての写真、学年、行事データは削除されますがよろしいですか？')) {
                this.axios.delete(`${process.env.API_URL}/photographer/${key}`).then((res) => {
                    location.reload()
                }).catch((e) => {
                    alert('サーバーエラーが発生しました')
                })
            }
        },
        add () {
            const params = this.$parent.requestParams

            this.axios.post(`${process.env.API_URL}/photographer${params}`, {
                id: this.$parent.id,
                name: this.name,
                email: this.email,
                code: this.code,
                password: this.password
            }).then((res) => {
                location.reload()
            }).catch((e) => {
                alert('サーバーエラーが発生しました')
            })
        },
        detail (key, e) {
            this.$router.push(`/photographer?id=${key}`)
        },
        autoGenerate (model) {
            this[model] = Math.random().toString(32).substring(2)
        }
    }
}
</script>

<style scoped>

.tabs {
    width: calc(100vw - 200px);
}
.content {
    margin: auto;
    padding: 25px;
    width: 780px;
}

.list {
}

.list-item {
    height: 48px;
    padding: 4px 12px;
    list-style: none;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.list-item:hover {
    background: rgba(31, 122, 224, 0.08);
}

.list-item:hover input:disabled {
    background: transparent;
    color: #222;
    cursor: pointer;
}

.list-item input {
    height: 40px;
    font-size: 18px;
    line-height: 40px;
    padding: 0 8px;
}

.list-item input:disabled {
    background: white;
    border: none;
    height: 40px;
    font-size: 18px;
    pointer-events: none;
}

.right-block {
    margin-left: auto;
    display: flex;
    align-items: center;
}

.icon {
    cursor: pointer;
    font-size: 22px;
    padding: 8px 10px;
}

.icon + .icon {
    margin-left: 10px;
}

.content-header {
    display: flex;
    padding-bottom: 20px;
}

.content-header h3 {
    line-height: 40px;
    margin: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/lab/pages/Photographer.vue